module.exports = __webpack_public_path__ + "static/media/Niveau_elN12_1_517303.da4e4b3b.png";